<template>
  <div>
  <ai-tab-nav />
  <div class="ai-rule-page">
    <page-header title="AI 规则库" :count="total">
      <template #actions>
        <el-button size="small" icon="el-icon-share" type="primary" plain @click="openMindMap">思维导图</el-button>
        <el-button size="small" icon="el-icon-plus" type="success" @click="openDialog(null)">新增规则</el-button>
        <el-button size="small" icon="el-icon-upload2" :loading="importing" @click="handleImport">从 MD 导入</el-button>
      </template>
      <el-select v-model="filter.sceneCode" placeholder="场景" clearable size="small" @change="loadList">
        <el-option label="供应商" value="supplier" />
        <el-option label="劳务" value="labor" />
        <el-option label="合同" value="contract" />
      </el-select>
      <el-select v-model="filter.categoryCode" placeholder="大类" clearable size="small" @change="loadList">
        <el-option label="合同协议" value="contract" />
        <el-option label="发票" value="invoice" />
        <el-option label="材料" value="material" />
        <el-option label="结算单" value="settlement" />
        <el-option label="会议相关" value="meeting" />
        <el-option label="其他" value="other" />
      </el-select>
      <el-select v-model="filter.feeType" placeholder="费用类型" clearable filterable size="small" @change="loadList">
        <el-option v-for="o in feeTypeOptions" :key="o.id" :label="o.dictLabel" :value="o.dictLabel" />
      </el-select>
      <el-select v-model="filter.enabled" placeholder="启用状态" clearable size="small" @change="loadList">
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button size="small" icon="el-icon-search" type="primary" @click="loadList">查询</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="resetFilter">重置</el-button>
    </page-header>

    <el-table :data="list" v-loading="loading" stripe border class="app-table" style="width:100%" size="small">
      <el-table-column prop="ruleCode" label="编号" width="80" />
      <el-table-column prop="ruleName" label="规则名称" min-width="180" show-overflow-tooltip />
      <el-table-column prop="sceneCode" label="场景" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini">{{ sceneLabel(row.sceneCode) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="categoryCode" label="大类" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" type="info">{{ categoryLabel(row.categoryCode) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="feeType" label="费用类型" width="120" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.feeType || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="docType" label="文档类型" width="120" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.docType || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="source" label="来源" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.source === 'md_import' ? '' : 'warning'">
            {{ row.source === 'md_import' ? 'MD导入' : (row.source || '手工') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="enabled" label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-switch :value="row.enabled === 1" @change="onToggle(row, $event)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="viewCheckItems(row)">检查项</el-button>
          <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="app-pagination">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :total="total"
        :current-page.sync="page.pageNum"
        :page-size="page.pageSize"
        @current-change="loadList" />
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id ? '编辑规则' : '新增规则'" :visible.sync="dialogVisible" width="640px" append-to-body>
      <el-form :model="editForm" label-width="100px" :rules="rules" ref="editFormRef" size="small">
        <el-form-item label="规则编号" prop="ruleCode">
          <el-input v-model="editForm.ruleCode" placeholder="如 R002" :disabled="!!editForm.id" />
        </el-form-item>
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="editForm.ruleName" placeholder="如 合作协议" />
        </el-form-item>
        <el-form-item label="场景" prop="sceneCode">
          <el-select v-model="editForm.sceneCode" style="width:100%">
            <el-option label="供应商" value="supplier" />
            <el-option label="劳务" value="labor" />
            <el-option label="合同" value="contract" />
          </el-select>
        </el-form-item>
        <el-form-item label="大类" prop="categoryCode">
          <el-select v-model="editForm.categoryCode" style="width:100%">
            <el-option label="合同协议" value="contract" />
            <el-option label="发票" value="invoice" />
            <el-option label="材料" value="material" />
            <el-option label="结算单" value="settlement" />
            <el-option label="会议相关" value="meeting" />
            <el-option label="其他" value="other" />
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-select v-model="editForm.feeType" filterable clearable allow-create placeholder="留空表示通用;可下拉选择或手工输入" style="width:100%">
            <el-option v-for="o in feeTypeOptions" :key="o.id" :label="o.dictLabel" :value="o.dictLabel" />
          </el-select>
        </el-form-item>
        <el-form-item label="文档类型">
          <el-select v-model="editForm.docType" filterable clearable allow-create placeholder="可下拉选择或手工输入;如 发票、合作协议、水单" style="width:100%">
            <el-option v-for="o in docTypeOptions" :key="o.id" :label="o.dictLabel" :value="o.dictLabel" />
          </el-select>
        </el-form-item>
        <el-form-item label="文件夹要求">
          <el-input v-model="editForm.folderReq" type="textarea" :rows="2" placeholder="(可选) 文件夹格式要求" />
        </el-form-item>
        <el-form-item label="文件格式">
          <el-input v-model="editForm.fileFormat" type="textarea" :rows="2" placeholder="(可选) 文件格式要求" />
        </el-form-item>
        <el-form-item label="命名要求">
          <el-input v-model="editForm.namingReq" type="textarea" :rows="2" placeholder="(可选) 命名要求" />
        </el-form-item>
        <el-form-item label="优先级">
          <el-input-number v-model="editForm.priority" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editForm.remark" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="editFormEnabled" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 思维导图弹窗 -->
    <ai-rule-mind-map ref="mindMap" />
  </div>
  </div>
</template>

<script>
import { aiRuleApi, aiImportApi, aiDictApi } from './api.js';
import AiTabNav from './AiTabNav.vue';
import AiRuleMindMap from './AiRuleMindMap.vue';
import PageHeader from '@/components/PageHeader.vue';

const SCENE_LABEL = { supplier: '供应商', labor: '劳务', contract: '合同' };
const CATEGORY_LABEL = {
  contract: '合同协议', invoice: '发票', material: '材料',
  settlement: '结算单', meeting: '会议相关', other: '其他', main: '合同主体'
};

export default {
  name: 'AiRuleManage',
  components: { AiTabNav, AiRuleMindMap, PageHeader },
  data() {
    return {
      list: [],
      loading: false,
      saving: false,
      importing: false,
      total: 0,
      page: { pageNum: 1, pageSize: 10 },
      filter: { sceneCode: '', categoryCode: '', feeType: '', enabled: null },
      feeTypeOptions: [],
      docTypeOptions: [],
      dialogVisible: false,
      editForm: this.emptyForm(),
      rules: {
        ruleCode: [{ required: true, message: '规则编号必填', trigger: 'blur' }],
        ruleName: [{ required: true, message: '规则名称必填', trigger: 'blur' }],
        sceneCode: [{ required: true, message: '场景必选', trigger: 'change' }],
        categoryCode: [{ required: true, message: '大类必选', trigger: 'change' }]
      }
    };
  },
  computed: {
    editFormEnabled: {
      get() { return this.editForm.enabled === 1; },
      set(v) { this.editForm.enabled = v ? 1 : 0; }
    }
  },
  created() {
    this.loadList();
    this.loadDicts();
  },
  methods: {
    sceneLabel(s) { return SCENE_LABEL[s] || s; },
    categoryLabel(c) { return CATEGORY_LABEL[c] || c; },

    /** 加载费用类型/文档类型字典供下拉使用 */
    async loadDicts() {
      try {
        const [feeResp, docResp] = await Promise.all([
          aiDictApi.options('fee_type'),
          aiDictApi.options('doc_type')
        ]);
        if (feeResp.code === 200) this.feeTypeOptions = feeResp.data || [];
        if (docResp.code === 200) this.docTypeOptions = docResp.data || [];
      } catch (e) { /* 不阻断,最多下拉为空 */ }
    },

    emptyForm() {
      return {
        id: null, ruleCode: '', ruleName: '', sceneCode: 'supplier', categoryCode: 'other',
        feeType: '', docType: '', folderReq: '', fileFormat: '', namingReq: '',
        enabled: 1, priority: 100, remark: ''
      };
    },

    async loadList() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.page.pageNum, pageSize: this.page.pageSize,
          ...this.filter
        };
        // 清空空字符串避免后端报错
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null) delete params[k]; });
        const resp = await aiRuleApi.page(params);
        if (resp.code === 200) {
          this.list = resp.data.records || [];
          this.total = resp.data.total || 0;
        } else {
          this.$message.error(resp.msg || '查询失败');
        }
      } catch (e) {
        this.$message.error('网络错误: ' + (e.message || e));
      } finally {
        this.loading = false;
      }
    },

    resetFilter() {
      this.filter = { sceneCode: '', categoryCode: '', feeType: '', enabled: null };
      this.page.pageNum = 1;
      this.loadList();
    },

    openDialog(row) {
      if (row) {
        this.editForm = { ...row };
      } else {
        this.editForm = this.emptyForm();
      }
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate());
    },

    handleSave() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const fn = this.editForm.id
            ? aiRuleApi.update(this.editForm.id, this.editForm)
            : aiRuleApi.create(this.editForm);
          const resp = await fn;
          if (resp.code === 200) {
            this.$message.success('保存成功');
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(resp.msg || '保存失败');
          }
        } catch (e) {
          this.$message.error('网络错误');
        } finally {
          this.saving = false;
        }
      });
    },

    handleDelete(row) {
      this.$confirm(`确认删除规则 ${row.ruleCode}「${row.ruleName}」?该操作不会自动删除其下的检查项`,
        '提示', { type: 'warning' }).then(async () => {
        const resp = await aiRuleApi.remove(row.id);
        if (resp.code === 200) {
          this.$message.success('已删除');
          this.loadList();
        } else {
          this.$message.error(resp.msg || '删除失败');
        }
      }).catch(() => {});
    },

    async onToggle(row, value) {
      const resp = await aiRuleApi.toggle(row.id, value);
      if (resp.code === 200) {
        row.enabled = value ? 1 : 0;
        this.$message.success(value ? '已启用' : '已禁用');
      } else {
        this.$message.error(resp.msg || '操作失败');
      }
    },

    viewCheckItems(row) {
      this.$router.push({ name: 'aiCheckItem', query: { ruleId: row.id, ruleCode: row.ruleCode } });
    },

    openMindMap() {
      this.$refs.mindMap.open();
    },

    handleImport() {
      this.$confirm('将从 classpath:rules/ 或 docs/ 目录的 MD 文件导入规则,已存在规则跳过。继续?',
        '提示', { type: 'info' }).then(async () => {
        this.importing = true;
        try {
          const resp = await aiImportApi.importDefault();
          if (resp.code === 200) {
            const d = resp.data;
            this.$message.success(`导入完成: 新规则 ${d.ruleCount}, 检查项 ${d.itemCount}, 跳过 ${d.skippedRuleCount}`);
            this.loadList();
          } else {
            this.$message.error(resp.msg || '导入失败');
          }
        } catch (e) {
          this.$message.error('导入失败: ' + (e.message || e));
        } finally {
          this.importing = false;
        }
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-rule-page {
  padding: 20px;
  background: #fff;
  min-height: 100%;

  /* .page-header 已抽到 PageHeader 组件 */

  .pagination-wrap {
    margin-top: 16px;
    text-align: right;
  }
}
</style>
